import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { apiPatchDispatchableWithoutSource } from '../../../../../core/dapi';
import { getUserProfileById } from '../../../../../core/dapi/userProfile';
import { receiveUserProfileForAccount, userProfileError } from '../../../../../actions/account';

export default () => {
  const dispatch = useDispatch();

  return useCallback(
    (userProfileId, userProfileData) => {
      dispatch(
        apiPatchDispatchableWithoutSource(
          getUserProfileById(userProfileId),
          userProfileData,
          receiveUserProfileForAccount,
          userProfileError
        )
      );
    },
    [dispatch]
  );
};
